import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { globalActions } from '../../../shared/store/globalSlice';

/**
 * Custom hook to track the loading state of different page components
 * @returns {Object} An object containing the updateTracker function
 * @returns {Function} updateTracker - Function to update the tracking state of a specific component
 */
const usePageTracker = (initKeys: string[]) => {
  const trackerMap: Record<string, boolean> = {};
  const dispatch = useDispatch();

  initKeys.forEach((key) => {
    trackerMap[key] = false;
  });

  const [pageTracker, setPageTracker] =
    useState<Record<string, boolean>>(trackerMap);

  // TO DO: Remove this effect when other APIs are integrated
  useEffect(() => {
    const isEverythingFinished = Object.values(pageTracker).every(
      (status) => status
    );

    if (isEverythingFinished) {
      dispatch(globalActions.setIsGlobalLoading(false));
    }
  }, [pageTracker, dispatch]);

  const updateTracker = (key: string, value: boolean) => {
    setPageTracker((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return { updateTracker };
};

// eslint-disable-next-line import/prefer-default-export
export { usePageTracker };
